import { render, staticRenderFns } from "./ProseccoHero.vue?vue&type=template&id=15180b2c&scoped=true&"
import script from "./ProseccoHero.vue?vue&type=script&lang=js&"
export * from "./ProseccoHero.vue?vue&type=script&lang=js&"
import style0 from "./ProseccoHero.vue?vue&type=style&index=0&id=15180b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15180b2c",
  null
  
)

export default component.exports